var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "498.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 498.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2310 5110 c-305 -26 -581 -97 -845 -216 -689 -311 -1192 -892 -1410 -1627 -31 -102 -27 -135 17 -172 l30 -25 390 0 390 0 29 31 c16 17 29 35 29 40 0 5 19 51 42 101 228 507 698 875 1244 974 120 22 408 25 529 5 232 -37 444 -115 635 -234 88 -56 214 -155 275 -216 l50 -51 -238 -238 c-255 -255 -269 -274 -242 -338 28 -67 -11 -64 864 -64 576 0 797 3 815 12 14 6 34 23 43 37 17 24 18 79 21 786 2 418 0 779 -3 803 -4 27 -17 55 -35 75 -24 27 -35 32 -74 32 l-46 0 -239 -239 -240 -239 -93 84 c-212 192 -387 313 -613 424 -250 123 -482 196 -747 236 -151 22 -433 32 -578 19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4069 2019 c-16 -17 -29 -35 -29 -40 0 -5 -19 -51 -42 -101 -227 -507 -699 -876 -1244 -974 -121 -22 -410 -25 -529 -5 -233 37 -444 115 -635 234 -88 56 -214 155 -275 216 l-50 51 238 238 c255 255 269 274 242 338 -28 67 11 64 -864 64 -576 0 -797 -3 -815 -12 -14 -6 -34 -23 -43 -37 -17 -24 -18 -79 -21 -786 -2 -418 0 -779 3 -803 4 -27 17 -55 35 -75 24 -27 35 -32 74 -32 l46 0 239 239 240 239 93 -84 c212 -192 387 -313 613 -424 250 -123 476 -194 750 -237 179 -28 525 -30 708 -5 420 58 810 212 1143 450 477 341 810 810 979 1380 31 102 27 135 -17 172 l-30 25 -390 0 -390 0 -29 -31z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateIcon);
export default __webpack_public_path__ + "static/media/UpdateIcon.fda2dea7bb34fa3afa3ec382b07e572d.svg";
export { ForwardRef as ReactComponent };